// GitInfoPage.js
import React from 'react';
import ReusableGitInfoPage from '../../b2b-common/pages/ReusableGitInfoPage';
import { fetchGitLanguageData } from '../../../services/b2b-languages-apiService';

const GitInfoPage = () => {
    return (
        <ReusableGitInfoPage bannerMessage="Languages Menu: Show Git commit info." fetchMethod={fetchGitLanguageData} />
    );
};

export default GitInfoPage;